// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3RLe1","inner":"Footer_inner__3DstS","nextIcon":"Footer_nextIcon__1xNPD","innerLeft":"Footer_innerLeft__2vhb4"};